import { render, staticRenderFns } from "./select-pick-up.component.vue?vue&type=template&id=b0ea1a1a"
import script from "./select-pick-up.component.ts?vue&type=script&lang=ts&external"
export * from "./select-pick-up.component.ts?vue&type=script&lang=ts&external"
import style0 from "./select-pick-up.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBottomSheet,VSheet,VVirtualScroll})
